export default "__VITE_ASSET__DnYJVRjI__"